export const GET_DAILY_TASK_REWARDS = "GET_DAILY_TASK_REWARDS";
export const UPDATE_DAILY_TASK_REWARDS = "UPDATE_DAILY_TASK_REWARDS";
